<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <path d="M15.1813 0.926893C14.029 -0.284951 12.1046 -0.309226 10.9222 0.873168L1.54735 10.2475C1.21952 10.5754 0.991977 10.9899 0.891421 11.4424L0.0138042 15.3923C-0.0232768 15.5592 0.0274821 15.7335 0.148381 15.8544C0.269279 15.9753 0.443557 16.026 0.610441 15.9889L4.53683 15.1157C5.00426 15.0118 5.43237 14.7767 5.77096 14.4381L15.129 5.08003C16.27 3.939 16.2932 2.09631 15.1813 0.926893ZM11.6293 1.58029C12.4142 0.795384 13.6917 0.811498 14.4566 1.61596C15.1947 2.39225 15.1793 3.61548 14.4218 4.37293L13.7506 5.04418L10.958 2.25155L11.6293 1.58029ZM10.2508 2.95864L13.0435 5.7513L5.06385 13.731C4.8597 13.9352 4.60158 14.0769 4.31975 14.1396L1.16044 14.8421L1.86762 11.6593C1.92692 11.3924 2.0611 11.148 2.25444 10.9547L10.2508 2.95864Z" />
  </svg>
</template>
